import React from 'react';
import { useTemplateConfig } from '../context/TemplateConfigContext';
import HeaderDefault from './Header';

const HeaderShell = () => {
    const { shellOverrides } = useTemplateConfig();
    const Override = shellOverrides?.HeaderComponent;

    if (Override) {
        return <Override />;
    }

    return <HeaderDefault />;
};

export default HeaderShell;
